import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import FooterPrivate from 'src/components/Footer/FooterPrivate';
import { isAuthenticated } from 'src/features/Auth';
import {
  PageContent,
  SidebarContent,
} from 'src/components/Navbar/Sidebar/Sidebar.styles';
import Sidebar from 'src/components/Navbar/Sidebar/Sidebar';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'src/app/store';
import { syncCompanyContext } from 'src/features/Auth/Auth.slice';
import { getEnterpriseProfile } from 'src/features/Dashboard';
import Navbar from '../components/Navbar/Navbar';

export interface Props {
  component: React.FC;
}

const PrivateRoute = ({ component: Component }: Props) => {
  const { isSideMenuExpanded } = useSelector((state: RootState) => state.home);
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    dispatch(syncCompanyContext());
    dispatch(getEnterpriseProfile());
  }, [dispatch]);

  return isAuthenticated() ? (
    <SidebarContent>
      <Sidebar />
      <PageContent className={isSideMenuExpanded ? 'blurred' : ''}>
        <Navbar />
        <Component />
        <FooterPrivate />
      </PageContent>
    </SidebarContent>
  ) : (
    <Navigate to={`/auth/signin?${params.toString()}`} />
  );
};

export default PrivateRoute;
